import vClickOutside from 'v-click-outside';
import {
	mapState,
	mapActions
} from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import pattern from '../../common/validators/pattern';
import { inputRegex } from '../../common/common';

const EMPTY_MODEL =  {
	nev: '',
	telefon: '',
	email: ''
};

export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	data() {
		return {
			model: Object.assign({}, EMPTY_MODEL)
		};
	},
	computed: {
		...mapState('concernModalStore', ['visible', 'success', 'fail', 'displayedAddress', 'displayedChoosenServices'])
	},
	methods: {
		...mapActions('concernModalStore', ['sendConcern', 'toggleModal', 'resetSuccess', 'resetFail']),
		toggle() {
			this.toggleModal().then(state => {
				if (!state) {
					this.resetSuccess();
					this.resetFail();
					this.resetModel();
				}
			});
		},
		submitConcern() {
			this.sendConcern(this.model);
		},
		resetModel() {
			this.model = Object.assign({}, EMPTY_MODEL);
			this.$v.model.$reset();
		}
	},
	validations() {
		return {
			model: {
				name: { required },
				email: { required, email },
				phone: { required, pattern: pattern([inputRegex.MOBILE_PHONE, inputRegex.LANDLINE_PHONE]) }
			}
		};
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL06-concern/MDL06-concern.js